var AlyleServiceConfig = (function () {
    function AlyleServiceConfig() {
    }
    return AlyleServiceConfig;
}());
export { AlyleServiceConfig };
function AlyleServiceConfig_tsickle_Closure_declarations() {
    /** @type {?} */
    AlyleServiceConfig.prototype.primary;
    /** @type {?} */
    AlyleServiceConfig.prototype.accent;
    /** @type {?} */
    AlyleServiceConfig.prototype.other;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/core/alyle-config-service.js
// module id = 267
// module chunks = 31